import { call, put, takeEvery } from "redux-saga/effects";
import { getData } from "@services/apiConfig";
import { FETCH_ENDPOINTS } from "../../../constants/action";
import {
  fetchEndpointSuccess,
  fetchEndpointFailure,
} from "../../../store/actions/endpoints";

function* handleMapperAction(action) {
  // Handle your asynchronous logic here
  try {
    const getObj = action.payload;
    const data = yield call(getData, getObj); // Call the API function
    if (data && Array.isArray(data)) {
      yield put(fetchEndpointSuccess(data)); // Dispatch success action
    } else {
      yield put(fetchEndpointSuccess([]));
    }
  } catch (error) {
    yield put(fetchEndpointFailure(error)); // Dispatch failure action
  }
}

export function* mapperSaga() {
  yield takeEvery(FETCH_ENDPOINTS, handleMapperAction);
}
